import $ from 'jquery';

const archiveLink = $( '.js-filter' ).attr( 'data-action' );

// Show more categories
$( document ).on( 'click', '.js-filters-more', function( e ) {
	e.preventDefault();
	const $parent = $( this ).parents( '.c-filters' );

	$( '.c-filters__item', $parent ).removeClass( 'u-hidden' );
	$( this ).hide();
} );

// On select change trigger submit
$( document ).on( 'change', '.js-filter-select', function( e ) {
	e.preventDefault();
	$( document ).trigger( 'rootworks:postsFilterSubmit' );
} );

// Do logic for selected button and trigger filter submit
$( document ).on( 'click', '.js-filter-button', function( e ) {
	e.preventDefault();
	const $self = $( this );
	const selectedClass = 'js-filter-button--selected';

	if ( ! $self.hasClass( selectedClass ) ) {
		$( '.js-filter-input' ).attr( 'value', $self.val() );
	} else {
		$( '.js-filter-input' ).attr( 'value', '' );
	}

	$( document ).trigger( 'rootworks:postsFilterSubmit' );
} );

// Submit filter values and add them as query params
$( document ).on( 'rootworks:postsFilterSubmit', function() {
	const url = new URL( archiveLink );
	const $selects = $( '.js-filter-select, .js-filter-input' );
	const searchValue = $( '.js-filter-search' ).val();

	$selects.each( function() {
		const value = $( this ).val();
		const key = $( this ).attr( 'name' );
		if ( value ) {
			url.searchParams.set( key, value );
		}
	} );

	if ( searchValue ) {
		url.searchParams.set( 's', searchValue );
	}

	window.location.href = url;
} );
